import { ISourceInfo } from '@patsnap/synapse_common_interface'
import { extractSourceInfoLink } from '@patsnap/synapse_domain'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { useDomainCtx } from '@pharmsnap/shared/src/composition/useDomainCtx'
import { usePreviewAttachment } from '@pharmsnap/shared/src/composition/usePreviewAttachment'
import { getRedirectLinkStatic } from '@pharmsnap/shared/src/utils'
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { GLink } from '../../ui/GLink/GLink'
export const BSourceInfoLink = defineComponent({
  name: 'BSourceInfoLink',
  props: {
    data: {
      type: Object as PropType<ISourceInfo>,
    },
    title: {
      type: String,
      default: '',
    },
    // 是否在整个行区域的时候才高亮
    hoverBlockHighlight: {
      type: Boolean,
      default: true,
    },
    truncate: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const domainCtx = useDomainCtx()
    const { locale } = useLocale()
    const linkInfo = computed(() => {
      if (!props.data) {
        return undefined
      }
      return extractSourceInfoLink(domainCtx, props.data)
    })
    const { handlePreviewAttachment } = usePreviewAttachment()
    return { linkInfo, handlePreviewAttachment, locale }
  },
  render() {
    const defaultNode = this.$slots.default || <span domPropsInnerHTML={this.title}></span>
    if (this.linkInfo?.type === 'link') {
      return (
        <GLink
          truncate={this.truncate}
          href={getRedirectLinkStatic(this.linkInfo.url, this.locale)}
          defaultColor={this.hoverBlockHighlight ? 'dark' : 'blue'}
          newTab={true}
        >
          {defaultNode}
        </GLink>
      )
    }
    if (this.linkInfo?.type === 'attachment') {
      return (
        <a
          class="text-blue-default pharm-hover--enable cursor-pointer hover:underline"
          onClick={() => this.data && this.handlePreviewAttachment(this.data)}
        >
          {defaultNode}
        </a>
      )
    }

    return <span>{defaultNode}</span>
  },
})
